export const DELIVERY_TERMS = {
  DEFAULT: 'default',
  EXPRESS: 'express',
}
